import React from "react";
import { Switch } from "@headlessui/react";
import clsx from "clsx";

interface ToggleProps {
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
}

const Toggle = ({ checked, disabled, onChange, label = "Use setting" }: ToggleProps) => {
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      className={clsx(
        `group relative inline-flex h-6 w-11 shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2`,
        checked ? "bg-primary-600" : "bg-gray-200",
        disabled ? "cursor-not-allowed" : "cursor-pointer",
        disabled && "opacity-50",
      )}
    >
      <span className="sr-only">{label}</span>
      <span
        className={`pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
          checked ? "translate-x-5" : "translate-x-0"
        }`}
      >
        <span
          aria-hidden="true"
          className={`absolute inset-0 flex h-full w-full items-center justify-center transition-opacity duration-200 ease-in ${
            checked ? "opacity-0" : "opacity-100"
          }`}
        >
          <svg fill="none" viewBox="0 0 12 12" className="h-3 w-3 text-gray-400">
            <path
              d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
        <span
          aria-hidden="true"
          className={`absolute inset-0 flex h-full w-full items-center justify-center transition-opacity duration-100 ease-out ${
            checked ? "opacity-100 duration-200 ease-in" : "opacity-0"
          }`}
        >
          <svg fill="currentColor" viewBox="0 0 12 12" className="h-3 w-3 text-neutral-500">
            <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
          </svg>
        </span>
      </span>
    </Switch>
  );
};

export default Toggle;
